function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-198.223 -160.013)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M199.123,166.851s9.6,12.049,20.25,0v-.546s-9.6-12.05-20.25,0Z",
  fill: "none",
  stroke: "#324655",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3.536,
  cy: 3.536,
  r: 3.536,
  transform: "translate(205.712 162.863)",
  strokeWidth: 0.65,
  stroke: "#324655",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "#324655"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 1.088,
  cy: 1.088,
  r: 1.088,
  transform: "translate(207.072 164.001)",
  strokeWidth: 0.57,
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "#fff"
}));

var SvgEye = function SvgEye(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eye",
    className: "stroke",
    width: 22.05,
    height: 13.129,
    viewBox: "0 0 22.05 13.129",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEye, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eye.c775ca7d.svg";
export { ForwardRef as ReactComponent };